import React from 'react';

interface SourceToggleProps {
  active: 'OF' | 'OT';
  busy?: boolean;
  size?: 'sm' | 'md';
  onSelect: (source: 'OF' | 'OT') => void;
}

/** Segmented OF/OT switch — sets the model_active_source override for a username. */
const SourceToggle: React.FC<SourceToggleProps> = ({ active, busy, size = 'sm', onSelect }) => (
  <div style={{ display: 'flex', gap: 6 }}>
    <button
      type="button"
      disabled={busy}
      className={`hf-btn ${size} ${active === 'OF' ? 'primary' : ''}`}
      onClick={() => onSelect('OF')}
    >
      OF
    </button>
    <button
      type="button"
      disabled={busy}
      className={`hf-btn ${size} ${active === 'OT' ? 'primary' : ''}`}
      onClick={() => onSelect('OT')}
    >
      OT
    </button>
  </div>
);

export default SourceToggle;
